import * as React from "react";
import { Component } from "react";

import { getClasses } from "utils";

import {
  SelectInputPropsType,
  SelectOptionType,
} from "components/FormElements/types";

interface StateType {
  expanded: boolean;
}

export default class SelectInput extends Component<
  SelectInputPropsType,
  StateType
> {
  static defaultProps = {
    onBlur(): void {},
  };

  mounted = true;

  state = {
    expanded: false,
  };

  trigger: HTMLButtonElement;

  componentDidMount(): void {
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onDocumentKeyDown);
  }

  componentWillUnmount(): void {
    this.mounted = false;
  }

  buildOptions(): SelectOptionType[] {
    const { placeholder } = this.props;
    let { options } = this.props;

    if (placeholder) {
      options = [
        { isPlaceholder: true, label: placeholder, value: placeholder },
        ...options,
      ];
    }

    return options;
  }

  closeDropdown = (): void => {
    if (!this.mounted || !this.state.expanded) return;
    this.setState({ expanded: false }, this.props.onBlur);
  };

  onChange =
    (value): (() => void) =>
    (): void => {
      const { name, onChange } = this.props;
      onChange({ currentTarget: { name, value } });
    };

  onDocumentClick = (event): void => {
    if (this.mounted && !this.trigger.contains(event.target)) {
      this.closeDropdown();
    }
  };

  onDocumentKeyDown = (event): void => {
    if (event.which === 27) this.closeDropdown();
  };

  onTriggerClick = (): void => {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  };

  valueToLabel(value): string {
    const options = this.buildOptions();

    for (let i = 0, l = options.length; i < l; i++) {
      const { label, value: optionValue } = options[i];
      if (value == optionValue) return label;
    }
  }

  Options = (): JSX.Element => {
    const options = this.buildOptions();
    const { value: selected } = this.props;

    const Items = options.map(({ isPlaceholder, label, value }) => (
      <li
        className={getClasses({
          placeholder: isPlaceholder,
          selected: selected == value && !isPlaceholder,
        })}
        key={label}
        onClick={this.onChange(value)}
      >
        {label}
      </li>
    ));

    return <ul>{Items}</ul>;
  };

  render(): JSX.Element {
    const { Options } = this;
    const { expanded } = this.state;
    const { id, name, value } = this.props;

    return (
      <div
        className={getClasses("form--select-input", { expanded })}
        {...{ id }}
        data-name={name}
      >
        <input type="hidden" {...{ name, value }} />

        <button
          className="button--white"
          onClick={this.onTriggerClick}
          ref={(el): void => {
            this.trigger = el;
          }}
          type="button"
        >
          <span>{this.valueToLabel(value)}</span>
          <i className="fas fa-caret-down" />
        </button>

        <Options />
      </div>
    );
  }
}
